<template>
  <ComDialog
    :isShow="dialogVisible"
    :width="350"
    title='设置分辨率'
    alignCenter
    @close="handleClose"
  >
    <el-form ref="formRef" :model="formData" :rules="rules">
    <el-form-item label="场景类型" prop="modeType">
     <el-radio-group v-model="formData.modeType">
        <el-radio v-for="item in modeTypes" :key="item.value" :label="item.value">{{item.label}}</el-radio>
    </el-radio-group>
      </el-form-item>
      <el-form-item label="分辨率类型" prop="screenRatio">
     <el-radio-group v-model="formData.screenRatio">
        <el-radio v-for="item in RESOLUTION_LIST" :key="item.value" :label="item.value">{{item.label}}</el-radio>
    </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="dialog-footer">
      <el-button  @click="dialogVisible=false">取消 </el-button>
      <el-button type="primary" :loading="loading" :disabled="loading" @click="submitForm">提交</el-button>
    </div>
  </ComDialog>
</template>
<script setup>
import { ref, defineExpose, defineEmits, nextTick } from "vue";
import ComDialog from "@/components/comDialog/index.vue";
import { useI18n } from "vue-i18n";
import request from "@/utils/request.ts";
import API_CONFIG from "../api.json";
import { ElMessage } from "element-plus";
import { getDictData } from "@/utils";
const emit = defineEmits(["freshLoad"]);
const loading = ref(false);
const { t } = useI18n();
const dialogVisible = ref(false);
const formRef = ref(null);
const currentData = ref([]);
const RESOLUTION_LIST = ref(getDictData('RESOLUTION_LIST'))
const modeTypes = ref([
  { label: "游戏场景", value: "1" },
  { label: "营销场景", value: "2" },
])
const formData = ref({
  screenRatio: '1'
  ,modeType: '1'
});
const rules = ref({
  screenRatio: [{ required: true, message: "请选择分辨率", trigger: "change" }],
  modeType: [{ required: true, message: "请选择场景类型", trigger: "change" }],
});

const open = data => {
  dialogVisible.value = true;
  currentData.value = data;
  formData.value = { screenRatio: '1',modeType: '1'};
  nextTick(() => {
    formRef.value.clearValidate();
  });
};

const handleClose = () => {
  dialogVisible.value = false;
};

const submitForm = async () => {
  const valid = await formRef.value.validate();
  if (!valid) return;
  loading.value = true;
  request
    .post(API_CONFIG.setScreenRatio.url, {
      ctrAliaList: currentData.value,
      type: formData.value.screenRatio,
      modeType: formData.value.modeType
    })
    .then(res => {
      if (res.code == 0) {
        const successData = (res.data||[]).filter(ele=>ele.success==true)
        const failureData = (res.data||[]).filter(ele=>ele.success!=true)
        if(successData.length==0){
          ElMessage.error(`设置成功0台，失败${failureData.length}台`);
        }else{
          ElMessage.success(`设置成功设备${successData.length}台，失败${failureData.length}台，成功设备需重启后生效，请耐心等待`);
        }
        dialogVisible.value = false;
      } else {
        ElMessage.error(res.msg);
      }
    })
    .finally(() => {
      loading.value = false;
    });
};

defineExpose({ open });
</script>
<style lang="scss" scoped>
.dialog-footer {
  text-align: center;
}
</style>